import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseApiTemplateService, Core2Config, ApiVisa } from "../shared";
import { AppTenantDeletionCleanupHistoryHdrContainerModel } from "../../../../../models/aggregates/app-tenant-deletion/app-tenant-deletion-cleanup-history-hdr-container.model";

@Injectable({
  providedIn: "root",
})
export class AppTenantDeletionCleanupHistoryHdrService extends BaseApiTemplateService<AppTenantDeletionCleanupHistoryHdrContainerModel> {
  constructor(http: HttpClient) {
    super();
    
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.PLATFORM_DOMAIN_URL_PREFIX +
      "applet/tenant-deletion-cleanup-history-hdrs/" + 
      Core2Config.BACKOFFICE_EP_SUFFIX;
    
    this.endpoint_path =
      Core2Config.PLATFORM_DOMAIN_URL_PREFIX +
      "applet/tenant-deletion-cleanup-history-hdrs/" + 
      Core2Config.BACKOFFICE_EP_SUFFIX;
    
    this.httpClient = http;
  }

}